export const EVENTS_LOADED = "adminEvents/EVENTS_LOADED";
export const EVENTS_LOAD_FAILED = "adminEvents/EVENTS_LOAD_FAILED";
export const RESET = "adminEvents/RESET";
